import React, { useEffect, useState } from "react";
import useAxios from "../../hooks/useAxios";
import { Loading } from "../../Components/Loading";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Card, Col, Row } from "react-bootstrap";
import SetPasswordForm from "../../Components/Staffs/SetPasswordForm";

const PasswordUpdate = () => {
  const { get } = useAxios();
  let { staffId } = useParams();
  const navigate = useNavigate();
  const [staff, setStaff] = useState({});
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    setFetching(true);
    const getDetailedStaff = async () => {
      try {
        const response = await get(`human_resources/staffs/${staffId}/show`);
        setStaff(response.data.userData);
      } catch (error) {
        if (error.response.status === 500) {
        }
      } finally {
        setFetching(false);
      }
    };
    getDetailedStaff();
  }, []);

  return (
    <>
      <Card className="container">
        <Card.Header className="d-flex justify-content-between mt-0 ">
          <Card.Title>
            <Row>
              <Col>
                <h1 className="page-title">Change Password</h1>
              </Col>
            </Row>
          </Card.Title>
          <Row>
            <Col>
              <Button onClick={() => navigate(-1)}>Back</Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          {!!fetching && <Loading />}

          {!!staff?.id && !fetching && <SetPasswordForm staff={staff} staffId={staffId} />}
        </Card.Body>
      </Card>
    </>
  );
};

export default PasswordUpdate;
